import { IDosage, IDuration } from '@alberta/konexi-shared';

export class DosageViewModel implements IDosage {
  packagingId: string;
  quantity: number;
  duration: IDuration;
}
